module.exports = __webpack_public_path__ + "media/academical-reborn.ba2949e1.mp4";